import React from "react";
import AllTradeReturns from "./TradeReturnModule/AllTradeReturns";

const TradeReturns = () => {
  return (
    <div>
      <AllTradeReturns />
    </div>
  );
};

export default TradeReturns;
